import React, { memo } from 'react';

function TwoFactorIllustration(props) {

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 400 360"    // era 0 0 1516 1267
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <path
        d="M335 298.57c0 6.715-74.996 12.145-167.5 12.145S0 305.263 0 298.57c0-6.715 74.996-12.145 167.5-12.145S335 291.855 335 298.57"
        fill="#F1F0F7"
      />
      <path
        d="M98.532 26.554c.953.887 1.33 2.106 1.219 3.369-.09 1.263-.643 2.416-.954 3.612-.443 1.663-.155 3.28 1.153 4.477 1.263 1.153 3.014 1.551 4.166 2.792 1.086 1.175 1.574 2.793 1.707 4.344.088 1.22.111 2.726-.576 3.812-.732 1.175-2.15 1.862-3.325 2.527-.31.177-.598.354-.93.532-.244.133-.466.265-.732.398-1.95 1.086-4.144 2.084-6.36 1.84-2.26-.244-4.056-1.662-4.433-3.945-.332-2.017.222-4.078-.2-6.094a4.1 4.1 0 0 0-.775-1.663c-.177-.155-.354-.288-.554-.443-1.396-.953-3.058-1.507-4.454-2.482-1.22-.842-2.239-2.017-2.793-3.39-.532-1.33-.642-2.771-.51-4.19.133-1.529.377-2.97-.221-4.432-.576-1.418-1.707-2.46-2.726-3.546-.93-.997-1.485-2.216-1.53-3.568-.066-1.485.533-2.681.976-4.055.399-1.242.399-2.46-.133-3.68-.51-1.218-1.396-2.216-2.083-3.346-.62-1.041-1.153-2.172-1.33-3.368C72.802 3.838 74.22 1.2 76.614.98c2.238-.222 4.21 1.75 5.385 3.435.864 1.263 1.307 2.703 1.95 4.055.355.732.798 1.419 1.44 1.906.665.488 1.485.643 2.261.909 1.485.532 2.97 1.33 3.878 2.66.865 1.262.931 2.77.754 4.232-.155 1.197-.554 2.505-.244 3.723.333 1.397 1.574 2.194 2.815 2.749 1.285.531 2.66.975 3.678 1.905"
        fill="url(#a)"
      />
      <path
        d="M73.178 6.055c.177 1.196.687 2.327 1.33 3.368.687 1.13 1.551 2.128 2.083 3.347.51 1.219.532 2.438.133 3.679-.443 1.374-1.042 2.57-.975 4.055.044 1.352.598 2.593 1.529 3.568 1.02 1.086 2.15 2.128 2.726 3.546.598 1.485.355 2.904.221 4.433-.11 1.396-.022 2.858.51 4.188a7.74 7.74 0 0 0 2.793 3.391c1.396.975 3.058 1.53 4.454 2.482.2.133.377.288.554.443a4.1 4.1 0 0 1 .776 1.663c.421 2.016-.133 4.077.2 6.094.376 2.283 2.171 3.701 4.432 3.945 2.194.244 4.388-.754 6.36-1.84l.732-.398.93-.532c1.153-.665 2.593-1.352 3.325-2.527.288-.443.443-.975.532-1.507-3.834-2.105-6.472-5.43-15.47-10.948-12.3-7.535-13.43-30.074-13.917-35.481-2.26.399-3.568 2.903-3.258 5.03"
        fill="url(#b)"
      />
      <path
        d="M83.44 17.778c.665 1.285.798 2.77 1.374 4.1l1.728 3.922c1.064 2.438 2.394 4.721 3.524 7.114 1.13 2.438 2.26 4.898 3.48 7.292 1.218 2.415 2.615 4.698 4.122 6.936a252 252 0 0 0 2.105 3.125c.399.576.842 1.13 1.241 1.729-.244.133-.465.266-.731.399-.532-.71-.998-1.485-1.463-2.172a75 75 0 0 1-2.371-3.524 82 82 0 0 1-3.923-6.936c-1.219-2.46-2.327-4.943-3.48-7.425-1.152-2.415-2.393-4.787-3.324-7.291-.443-1.219-1.02-2.393-1.418-3.635-.399-1.196-.443-2.482-.909-3.634-.066-.044.023-.044.045 0"
        fill="#2DA59A"
      />
      <path
        d="M101.48 47.586c.443 2.04-.753 3.68-2.216 4.987l-.067.066c-.177.155-.354.31-.532.443-1.662 1.374-3.612 2.483-5.65 3.147-1.397.444-3.015.687-4.5.4-1.795.376-3.59.398-5.097-.887-.842-.71-1.551-1.574-2.438-2.26-1.02-.754-2.15-.931-3.39-.798-1.153.11-2.283.376-3.436.354-1.24-.044-2.37-.465-3.412-1.13-1.042-.687-1.84-1.64-2.66-2.593-.598-.687-1.263-1.463-2.216-1.596-2.083-.31-3.879 1.596-6.006 1.02-1.995-.554-2.881-2.748-4.787-3.413-1.152-.4-2.438-.2-3.546-.798-.886-.488-1.396-1.33-1.374-2.327.066-2.46 2.216-4.588 4.588-4.898 1.351-.177 2.659.222 3.989.2 1.041-.023 1.773-.466 2.482-1.175 1.263-1.219 2.57-2.815 4.52-2.549 2.993.4 5.032 5.12 8.312 3.568 1.196-.576 2.127-1.64 3.324-2.238a4.06 4.06 0 0 1 3.369-.155c1.019.399 1.95 1.285 2.637 2.105.665.798 1.307 1.729 2.282 2.194.887.4 1.95.266 2.904.244 1.352-.044 2.66.155 3.944.532 2.128.643 4.1 1.862 5.807 3.236 1.396 1.063 2.77 2.526 3.169 4.321"
        fill="url(#c)"
      />
      <path
        d="M99.22 52.617c-.178.155-.355.31-.532.444-.998-.444-1.995-.91-2.97-1.352-1.33-.62-2.57-1.352-3.834-2.061-2.216-1.22-4.565-2.128-6.959-2.948-2.371-.82-4.831-1.684-7.291-2.15-2.371-.42-4.81-.576-7.225-.842-2.15-.244-4.565-.377-6.493-1.462-.045-.023-.022-.111.044-.09 2.504.887 5.208.865 7.823 1.065 2.482.2 4.987.266 7.402.908a75 75 0 0 1 7.18 2.217 44.5 44.5 0 0 1 6.915 3.213c1.928 1.108 4.034 1.884 5.94 3.058"
        fill="#2DA59A"
      />
      <path
        d="M224.321 242.678H115.152c-8.644 0-15.625-7.003-15.625-15.624V35.508c0-8.643 7.004-15.624 15.625-15.624h109.169c8.643 0 15.624 7.003 15.624 15.624v191.524c0 8.643-7.003 15.646-15.624 15.646"
        fill="#4C7EF9"
      />
      <path
        d="M224.832 19.884H114.62c-8.355 0-15.114 7.247-15.114 16.179v190.459c0 8.932 6.759 16.178 15.114 16.178h1.574c-8.244 0-14.915-7.158-14.915-15.978V38.655c0-8.82 6.693-15.978 14.915-15.978h108.837c8.244 0 14.915 7.158 14.915 15.978v-2.593c0-8.93-6.759-16.178-15.114-16.178"
        fill="#2BC6FF"
      />
      <path
        d="M222.57 234.589H116.88c-5.385 0-9.751-4.366-9.751-9.751V37.724c0-5.385 4.366-9.75 9.751-9.75h105.69c5.386 0 9.752 4.365 9.752 9.75V224.86c0 5.363-4.366 9.729-9.752 9.729"
        fill="#fff"
      />
      <path
        d="M212.044 188.559h-84.769a3.883 3.883 0 0 1-3.879-3.879v-10.549a3.883 3.883 0 0 1 3.879-3.878h84.769a3.883 3.883 0 0 1 3.879 3.878v10.549a3.87 3.87 0 0 1-3.879 3.879"
        fill="#ECEAF9"
      />
      <path
        d="m142.433 176.569-1.906 2.526v.045l3.036-.399v1.374l-3.036-.355v.044l1.928 2.416-1.263.732-1.219-2.815h-.044l-1.308 2.837-1.152-.732 1.906-2.46v-.044l-2.992.377v-1.374l2.97.376v-.044l-1.906-2.46 1.218-.709 1.242 2.792h.044l1.219-2.814z"
        fill="#AAA5D6"
      />
      <path
        d="m138.71 183.24-1.551-.975 1.773-2.283-2.748.355v-1.84l2.726.355-1.773-2.283 1.64-.931 1.174 2.615 1.153-2.637 1.617.909-1.795 2.349 2.815-.377v1.84l-2.815-.333 1.795 2.261-1.684.975-1.13-2.66zm-.931-1.086.754.465 1.263-2.748h.266l.089.133 1.108 2.615.842-.487-1.817-2.283v-.31l.243-.022 2.815.332v-.886l-3.036.399v-.311l.044-.088 1.773-2.327-.798-.444-1.197 2.726h-.266l-.088-.133-1.153-2.593-.82.466 1.796 2.327v.31h-.244l-2.726-.354v.886l2.992-.377v.31l-.045.089zm19.48-5.585-1.906 2.526v.045l3.036-.399v1.374l-3.036-.355v.044l1.928 2.416-1.263.732-1.219-2.815h-.044l-1.308 2.837-1.152-.732 1.906-2.46v-.044l-2.992.377v-1.374l2.97.376v-.044l-1.906-2.46 1.219-.709 1.241 2.792h.044l1.219-2.814z"
        fill="#AAA5D6"
      />
      <path
        d="m153.558 183.24-1.552-.975 1.773-2.283-2.748.355v-1.84l2.726.355-1.773-2.283 1.64-.931 1.175 2.615 1.152-2.637 1.618.909-1.795 2.349 2.814-.377v1.84l-2.814-.333 1.795 2.261-1.684.975-1.131-2.66zm-.931-1.086.753.465 1.264-2.748h.266l.088.133 1.108 2.615.842-.487-1.817-2.283v-.31l.244-.022 2.815.332v-.886l-3.037.399v-.311l.045-.088 1.773-2.327-.798-.444-1.197 2.726h-.266l-.089-.133-1.152-2.593-.82.466 1.795 2.327v.31h-.244l-2.726-.354v.886l2.992-.377v.31l-.044.089zm19.482-5.585-1.906 2.526v.045l3.036-.399v1.374l-3.036-.355v.044l1.928 2.416-1.263.732-1.219-2.815h-.044l-1.308 2.837-1.152-.732 1.905-2.46v-.044l-2.991.377v-1.374l2.969.376v-.044l-1.906-2.46 1.219-.709 1.241 2.792h.045l1.219-2.814z"
        fill="#AAA5D6"
      />
      <path
        d="m168.386 183.24-1.552-.975 1.773-2.283-2.748.355v-1.84l2.726.355-1.773-2.283 1.64-.931 1.175 2.615 1.152-2.637 1.618.909-1.795 2.349 2.815-.377v1.84l-2.815-.333 1.795 2.261-1.684.975-1.13-2.66zm-.931-1.086.754.465 1.263-2.748h.266l.088.133 1.108 2.615.843-.487-1.818-2.283v-.31l.244-.022 2.815.332v-.886l-3.037.399v-.311l.045-.088 1.773-2.327-.798-.444-1.197 2.726h-.266l-.088-.133-1.153-2.593-.82.466 1.795 2.327v.31h-.243l-2.726-.354v.886l2.991-.377v.31l-.044.089zm19.501-5.585-1.905 2.526v.045l3.036-.399v1.374l-3.036-.355v.044l1.928 2.416-1.264.732-1.219-2.815h-.044l-1.307 2.837-1.153-.732 1.906-2.46v-.044l-2.992.377v-1.374l2.97.376v-.044l-1.906-2.46 1.219-.709 1.241 2.792h.044l1.219-2.814z"
        fill="#AAA5D6"
      />
      <path
        d="m183.233 183.239-1.551-.975 1.773-2.282-2.748.354v-1.839l2.726.354-1.773-2.282 1.64-.931 1.175 2.615 1.152-2.637 1.618.908-1.795 2.35 2.814-.377v1.839l-2.814-.332 1.795 2.26-1.684.975-1.131-2.659zm-.93-1.085.753.465 1.263-2.748h.266l.089.133 1.108 2.615.842-.488-1.817-2.282v-.311l.244-.022 2.814.333v-.887l-3.036.399v-.31l.044-.089 1.773-2.327-.797-.443-1.197 2.726h-.266l-.089-.133-1.152-2.593-.82.465 1.795 2.327v.311h-.244l-2.726-.355v.887l2.992-.377v.31l-.044.089zm19.478-5.585-1.906 2.527v.044l3.036-.399v1.374l-3.036-.354v.044l1.928 2.416-1.263.731-1.219-2.815h-.045l-1.307 2.837-1.153-.731 1.906-2.46v-.044l-2.992.376v-1.374l2.97.377v-.044l-1.906-2.46 1.219-.71 1.241 2.793h.045l1.218-2.815z"
        fill="#AAA5D6"
      />
      <path
        d="m198.058 183.24-1.552-.975 1.773-2.283-2.748.355v-1.84l2.726.355-1.773-2.283 1.64-.931 1.175 2.615 1.152-2.637 1.618.909-1.795 2.349 2.814-.377v1.84l-2.814-.333 1.795 2.261-1.684.975-1.131-2.66zm-.931-1.086.753.465 1.264-2.748h.266l.088.133 1.108 2.615.842-.487-1.817-2.283v-.31l.244-.022 2.815.332v-.886l-3.037.399v-.311l.045-.088 1.773-2.327-.798-.444-1.197 2.726h-.266l-.089-.133-1.152-2.593-.82.466 1.795 2.327v.31h-.244l-2.726-.354v.886l2.992-.377v.31l-.044.089z"
        fill="#AAA5D6"
      />
      <path
        d="M84.77 138.251c-2.171-.355-3.9 2.261-8.797 5.518-.488.333-1.02.71-1.596 1.108.842 1.441 1.64 2.904 2.593 4.256.909-1.374 1.884-2.327 2.859-2.416 3.767-.355 6.227-1.862 6.227-1.862s1.153 1.463 2.283 1.131c1.13-.355 1.729-2.483 2.194-3.125.488-.643-3.59-4.278-5.762-4.61"
        fill="#F9C5AF"
      />
      <path
        d="M58.354 144.678c-3.967-2.261-8.799 1.551-7.469 5.895 2.35 7.734 6.582 10.704 7.602 11.768 1.728 1.839 6.028 2.571 9.108.62 3.059-1.95 12.256-14.183 12.256-14.183l-4.144-6.737-10.417 10.238a.457.457 0 0 1-.753-.177l-4.676-6.56z"
        fill="#94D270"
      />
      <path
        d="M83.176 155.382h16.998a2.58 2.58 0 0 0 2.438-1.729l11.635-32.356c.376-.864-.51-1.884-1.241-1.884H94.789a2.61 2.61 0 0 0-2.46 1.729L81.07 152.39c-.51 1.463.554 2.992 2.106 2.992"
        fill="#2B3749"
      />
      <path
        d="M81.734 155.382h16.998a2.58 2.58 0 0 0 2.438-1.729l11.79-32.799a1.078 1.078 0 0 0-1.019-1.441H93.325a2.61 2.61 0 0 0-2.46 1.729L79.606 152.39c-.465 1.463.599 2.992 2.128 2.992"
        fill="#3B4C60"
      />
      <path
        d="M83.818 150.794h15.58c.643 0 1.219-.399 1.418-.997l9.131-25.398c.355-.997-.377-2.039-1.418-2.039h-15.16c-.642 0-1.218.399-1.44 1.02l-9.285 25.774a1.24 1.24 0 0 0 1.174 1.64"
        fill="#FFFFFD"
      />
      <path
        d="M105.624 121.43h-5.252c-.355 0-.576-.199-.421-.377l.266-.576c.088-.111.465-.111.664-.111h5.142c.399 0 .532.111.488.443l-.266.488c-.089.089-.421.133-.621.133m-6.669-.399c-.09.31-.4.51-.688.421-.31-.066-.487-.399-.398-.709s.398-.51.687-.421c.288.066.487.399.398.709"
        fill="#2B3749"
      />
      <path
        d="M99.752 134.639c-1.418 1.728-3.635 2.105-4.986.842-1.352-1.264-1.308-3.679.11-5.408 1.419-1.728 3.635-2.105 4.987-.842 1.352 1.285 1.307 3.701-.111 5.408"
        fill="#6ABE44"
      />
      <path
        d="M96.45 134.262a.47.47 0 0 1-.289-.222l-1.13-1.906a.575.575 0 0 1 .11-.709c.2-.177.444-.133.577.089l.975 1.639 2.372-2.016c.199-.155.443-.111.576.111a.61.61 0 0 1-.133.709l-2.615 2.216a.67.67 0 0 1-.444.089"
        fill="#FCFAFC"
      />
      <path
        d="M98.978 145.365h-11.37c-.221 0-.376-.111-.354-.222l.332-1.174c.023-.089.178-.156.355-.156h11.37c.22 0 .376.111.354.222l-.333 1.175c-.022.066-.177.155-.354.155"
        fill="#6ABE44"
      />
      <path
        d="M93.902 143.813h-5.94c-.177 0-.332.067-.354.156l-.333 1.174c-.022.111.133.222.355.222h6.006z"
        fill="#4F962A"
      />
      <path d="m61.28 285.14 1.307 8.909 5.363-.199.399-9.22z" fill="#F9C5AF" />
      <path
        d="m67.662 293.207-5.274.111a.494.494 0 0 0-.466.399l-1.02 4.986c-.088.444.2.865.621.975a.5.5 0 0 0 .178.023c2.194-.089 4.166-.244 6.892-.288 3.236-.067 2.416.354 6.227.332 2.283-.022 2.66-2.615 1.685-2.726-4.455-.488-5.762-1.817-7.513-3.369a1.94 1.94 0 0 0-1.33-.443"
        fill="#242345"
      />
      <path
        d="m35.127 285.14-.332 7.89 5.563.731 1.861-9.131z"
        fill="#F9C5AF"
      />
      <path
        d="m40.026 292.32-5.275-.332a.5.5 0 0 0-.51.355l-1.418 4.875a.81.81 0 0 0 .554 1.02c.067.022.111.022.178.022 2.194.111 4.166.111 6.892.288 3.236.221 2.394.554 6.183.842 2.283.177 2.881-2.393 1.906-2.593-4.41-.842-5.585-2.283-7.203-3.989a2.26 2.26 0 0 0-1.307-.488"
        fill="#242345"
      />
      <path
        d="M43.305 200.304c-1.64 7.025-2.526 13.275-2.504 16.555 0 1.175.066 2.128.155 2.903.266 2.327-.377 4.034-.532 6.361l-.044.598c-.444 6.76-.532 13.652-.51 18.217v.089c0 2.992-.487 5.939-1.485 8.776-.155.443-.31.887-.443 1.352-4.1 13.142-3.768 34.129-3.768 34.129l7.979.421 21.94-90.066-19.17-.642a1.724 1.724 0 0 0-1.618 1.307"
        fill="#4A5082"
      />
      <path
        opacity=".2"
        d="m54.031 214.599-2.726-.576-1.684-1.906s.177 14.25 4.61 28.145l4.321-17.729z"
        fill="#000"
      />
      <path d="m33.486 287.689.111 2.349 9.087.377.399-2.394z" fill="#007CFF" />
      <path
        d="m33.488 287.688.111 2.35 9.087.376.398-2.393zm16.645-88.026c-1.861 10.416-.709 16.355.532 19.458.111.31.244.576.355.82a20.1 20.1 0 0 1 1.817 5.917c.022.089.022.199.044.288 1.153 8.067 3.347 16.555 4.677 21.231 0 .022.022.045.022.067.576 2.061.753 4.211.443 6.338-.11.687-.177 1.441-.244 2.216-.886 12.123 3.391 34.218 3.391 34.218l7.801-.665 3.413-88.847a1.01 1.01 0 0 0-1.02-1.041z"
        fill="#4A5082"
      />
      <path d="m60.147 289.04.664 2.283 8.777-.754.132-2.415z" fill="#007CFF" />
      <path d="m60.147 289.04.664 2.283 8.777-.754.132-2.415z" fill="#4A5082" />
      <path
        d="M64.85 130.051c.642 2.837 1.64 3.48 1.418 4.056-.2.576-2.305 1.064-2.305 1.064s.598-4.211.886-5.12"
        fill="#FEB48C"
      />
      <path
        d="M64.36 118.793s1.286.554 1.264 5.784c0 1.33-.377 3.967-.687 5.895-.2 3.657 1.02 3.502-1.707 11.369 0 0-3.125.798-8.998-1.95z"
        fill="#F9C5AF"
      />
      <path
        d="M50.043 139.891c2.194 2.305 5.185 1.263 8.288-3.59.067-.598.133-1.152.244-1.684-.421 5.385 2.482 6.006 4.632 7.224 0 0-.355.754-2.815.244l.776 5.319-11.879.776c.288-1.374.554-5.784.71-8.267z"
        fill="#FEB48C"
      />
      <path
        d="M47.14 116.023c2.106-3.036 12.057-1.396 16.4 0 4.588 1.485 3.524 3.391 3.347 4.033-.421 1.485-2.46 2.128-3.39 2.349-.843 1.663-2.04 5.053-1.707 10.306l-1.618.177s.244-1.529-.111-2.549c-.776 1.618-1.463 3.347-1.706 5.962-3.192 5.009-6.272 5.962-8.488 3.413-1.552-2.704-5.098-5.496-6.383-11.724-.975-4.499 0-8.732 3.657-11.967"
        fill="#282633"
      />
      <path
        d="m46.189 116 .332-.509c.688-1.884 2.638-2.948 5.386-3.303 3.657-.487 13.009 4.167 13.23 1.397 6.25 1.972 1.995 8.089-1.795 8.643-.864 1.573-11.9 5.119-17.796 2.216-4.144-2.039-1.196-6.693.643-8.444"
        fill="#312F3D"
      />
      <path
        d="M57.402 132.356c.177 1.308 1.108 2.216 2.083 2.039s1.64-1.374 1.463-2.682c-.178-1.307-1.108-2.216-2.084-2.039-.975.156-1.64 1.374-1.462 2.682"
        fill="#F9C5AF"
      />
      <path
        d="M59.663 133.154c-.466.088-.931-.355-.998-.976-.088-.62.222-1.218.71-1.307a.7.7 0 0 1 .51.133c-.222-.266-.533-.421-.865-.377-.576.111-.953.82-.864 1.574.11.775.642 1.307 1.218 1.196.222-.044.4-.199.554-.376a.8.8 0 0 1-.265.133"
        fill="#FEB48C"
      />
      <path
        d="M69.435 180.092c1.197-6.271 2.526-14.228 2.526-14.228s0-2.304.045-2.304l.088-2.593c.067-11.48-7.113-12.5-7.113-12.5h.022l-2.04-2.149-14.693-.377s-7.402 1.906-8.687 11.325 4.61 25.309 3.413 31.58c-1.197 6.272-3.879 16.201-.599 17.575 3.28 1.396 25.354.886 29.653-3.214 4.255-4.055-3.834-16.843-2.615-23.115"
        fill="#A8F17E"
      />
      <path
        opacity=".15"
        d="M69.435 180.092c.998-5.208 2.084-11.59 2.416-13.585 0-.133.022-.288.022-.421 0-.111.022-.222.022-.332.111-2.128.178-3.812.2-4.566v-.177c0-1.285-.089-2.416-.244-3.457-4.1.465-5.208 2.127-5.208 2.127s-.421 1.64-.687 4.1c-.997 9.22-1.729 12.699-1.862 18.018s3.613 5.407 3.369 14.959c-.133 5.164-6.028 8.311-11.436 10.128 2.837-.177 5.674-.443 8.245-.82 3.523-.62 6.449-1.529 7.756-2.77 4.277-4.144-3.812-16.932-2.593-23.204"
        fill="#231F20"
      />
      <path
        d="M102.414 144.878c.443-2.549-4.92-3.347-4.92-3.347s1.063-2.438 1.972-4.344-.355-1.241-.355-1.241c-3.59 3.147-6.936 8.355-6.382 10.815s-1.286 4.809-1.286 4.809l4.81 2.128s2.725-3.878 3.257-4.743c.51-.864 2.46-1.551 2.904-4.077"
        fill="#F9C5AF"
      />
      <path
        d="M69.215 150.95a8767 8767 0 0 1 10.837 14.117s1.64-2.97 2.083-.51l9.486-15.668s4.077-.156 7.18 3.634c0 0-9.663 22.073-15.247 24.024-5.607 1.95-19.769-10.261-19.769-10.261l2.815-14.295c-.2-1.44 1.728-2.216 2.615-1.041"
        fill="#A8F17E"
      />
      <path
        d="m49.045 142.994-1.795 3.302s2.394 1.174 15.026.066l-1.02-3.08s-7.247 1.241-12.21-.288"
        fill="#FFF8ED"
      />
      <path
        d="m274.874 286.359.532 5.43s-5.319 2.261-6.25 1.197c-.953-1.086-1.596-.798-1.596-.798l-.443-6.87zm23.138-1.662-.332 5.208-6.915-.354-.82-5.807z"
        fill="#22313B"
      />
      <path
        d="M296.174 196.848s.376 13.629-.399 21.43c-.798 7.801-2.261 27.326-1.086 33.132 1.086 5.341 4.388 28.7 5.008 35.482.067.753-.554 1.396-1.329 1.396-3.059.022-7.934.509-8.754-.975-1.064-1.906-8.998-31.603-10.195-37.41-1.174-5.806-3.346-10.615-3.346-10.615s-.798 7.801-.621 13.651l.975 34.418c.022.842-.731 1.529-1.595 1.44-2.771-.243-6.161-.288-8.422-.953 0 0-3.635-22.893-4.942-33.553-1.308-10.682-2.327-53.144.465-57.621 2.748-4.454 34.241.178 34.241.178"
        fill="#3F4752"
      />
      <path
        d="M299.674 286.891c.067.754-.554 1.397-1.33 1.397-.664 0-1.507 0-2.437-.023-1.574-10.925-7.114-42.129-8.178-48.822-.931-5.785 1.861-30.539 3.324-42.684 3.081.022 5.12.088 5.12.088s.376 13.63-.399 21.431c-.798 7.801-2.261 27.326-1.086 33.132 1.064 5.341 4.388 28.722 4.986 35.481m-26.771-69.411c1.13 3.857 3.634 22.938 3.634 22.938-.288-.709-.465-1.13-.465-1.13s-.798 7.801-.621 13.652l.975 34.417c.023.842-.731 1.529-1.595 1.441-2.327-.2-4.965-.355-7.624-.865 1.906-.376 4.831-1.706 5.585-3.257.953-1.973-2.083-37.92-2.083-37.92 1.817-6.87 2.194-29.276 2.194-29.276"
        fill="#2F3740"
      />
      <path
        d="M298.811 290.127s-7.557-2.549-9.397-1.574c0 0 .045 1.84-.864 2.793s-6.36 6.626-5.407 7.535c.953.886 10.327 1.551 15.89-.443zm-23.314.487c.31-.022.598.2.598.532l.2 6.959s.864.82-4.211.953c-5.075.155-18.594.532-19.48-.288-.865-.82-.045-1.684 4.122-3.479 4.189-1.795 8.754-4.876 10.394-6.605 0 0 3.391-.088 2.615 2.438.022.045.798.022 5.762-.51"
        fill="#2D313D"
      />
      <path
        d="M306.966 181.844c.221-1.242.244-3.28.133-4.544-.288-3.213-.975-6.404-1.308-9.618-.509-4.853-.62-10.638-2.992-15.247-.62-1.197-1.507-2.394-2.637-3.236-.133-.089-.288-.155-.421-.244-.576-.288-1.152-.354-1.751-.199a5 5 0 0 0-.975.443 4.2 4.2 0 0 0-.997.754c-.599.598-1.02 1.329-1.374 2.105a12.5 12.5 0 0 0-1.064 4.565c-.044 1.374.066 2.77.266 4.145.842 2.504 1.751 5.008 2.194 7.601.288 1.773.643 3.546.909 5.319.243 1.662.443 3.324.532 4.986.088 1.374.132 2.837.709 4.145.288.642.709 1.241 1.307 1.684.621.443 1.396.687 2.172.776 1.352.133 2.815-.133 3.723-1.042.798-.82 1.374-1.285 1.574-2.393"
        fill="#FCC2B4"
      />
      <path
        d="M272.104 144.39s-5.23-.354-8.466 3.192c-3.235 3.545-12.632 19.524-12.632 19.524s2.681 3.391 8.421 4.987c.2.066.421.11.621.155 6.139 1.507 12.056-27.858 12.056-27.858"
        fill="url(#d)"
      />
      <path
        d="M306.657 170.541s-1.951-16.511-3.945-20.832c-2.017-4.322-10.394-5.674-10.394-5.674-.576-.155-1.175-.288-1.773-.443-7.314-1.618-14.937-.931-21.896 1.795h-.022s-3.48 8.643-4.854 20.988c-.997 9.064-3.568 33.619-3.568 33.619s16.023 5.563 36.146-.377c0 0-.908-17.153-.354-28.3 2.504.088 7.801.177 10.66-.776"
        fill="url(#e)"
      />
      <path
        d="M287.618 143.082a37.6 37.6 0 0 0-13.629.643c-1.131.997-2.017 4.056-.51 4.898 2.017 1.152 5.208 2.903 9.95.044 3.037-1.839 4.655-4.078 4.189-5.585"
        fill="#4D5383"
      />
      <path
        d="M275.14 144.013c-.754 1.463-1.972 2.571.288 3.834 1.529.864 3.214.997 4.765.421a15.1 15.1 0 0 0 5.097-3.191c.421-.399.82-.842.997-1.374.466-1.308-.842-2.084-.953-3.28-.31-3.613-.753-7.38-.487-11.037.022-.399.044-.82.199-1.197a.67.67 0 0 0-.288-.266c-.465-.199-1.041-.11-1.507 0-.554.133-1.086.333-1.618.51-1.285.399-2.57.909-3.745 1.551-1.152.643-2.127 1.485-3.147 2.327-.332.288-.709.51-.997.843-.111.11-.244.288-.244.443 0 .244.266.377.377.532.82 1.108 1.152 2.814 1.396 4.188.266 1.529.488 3.103.244 4.654a5.7 5.7 0 0 1-.377 1.042"
        fill="#FCC2B4"
      />
      <path
        d="M275.141 144.013c5.319.554 8.577-2.748 10.084-4.787-.199-2.083-.377-4.233-.443-6.36l-.798-.067-10.505.732c0 .022-.022.066-.022.088 0 .244.266.377.377.532.82 1.108 1.152 2.815 1.396 4.189.266 1.529.488 3.102.244 4.654-.045.377-.178.709-.333 1.019"
        fill="#FBA896"
      />
      <path
        d="m294.576 157.731.377 4.743 1.019 8.865c.621.022 1.441.022 2.327.044z"
        fill="#B1B0F2"
      />
      <path
        d="M254.687 176.303c-9.862-5.762-17.862-13.518-20.544-17.131-1.152-1.551-.155-3.701 1.596-2.859 0 0 15.358 6.738 23.735 11.879.089.798-3.812 7.713-4.787 8.111"
        fill="#FCC2B4"
      />
      <path
        d="M259.606 168.258c-2.039-1.041-4.743-.088-6.028 2.15-1.308 2.239-.71 4.898 1.329 5.94 2.039 1.041 4.743.088 6.051-2.15 1.285-2.216.687-4.876-1.352-5.94"
        fill="#FCC2B4"
      />
      <path
        d="M231.128 157.598s-3.922-.531-4.764-.82c-.843-.266-4.189-2.371-4.81-2.171-.62.199-.509.886.421 1.595.798.599 2.882 1.906 3.458 2.261.598.377 4.632 1.285 5.429 1.086.798-.2 1.729-1.951.266-1.951"
        fill="#F2B3A7"
      />
      <path
        d="M232.79 155.116s-4.565-.82-6.848-1.329c-2.282-.51-4.897-.865-5.23-.178-.332.665 1.795.953 3.901 1.507 2.105.576 6.67 1.928 7.535 1.751.886-.199 1.751-1.618.642-1.751"
        fill="#FCC2B4"
      />
      <path
        d="M232.126 156.113s-4.898-.62-7.38-1.174-5.363-1.197-5.74-.466 2.017 1.264 4.3 1.884c2.282.621 7.18 1.862 8.133 1.662.931-.221 1.884-1.75.687-1.906"
        fill="#FCC2B4"
      />
      <path
        d="M238.686 158.241c-.11 1.175-1.241 2.549-2.859 2.903-.82.178-2.149-.044-3.346-.332s-2.283-.621-2.659-.82c-.732-.443-1.906-.909-1.175-2.261.355-.665 3.191-3.9 4.366-4.476 1.152-.599 5.718 4.41 5.673 4.986"
        fill="#FCC2B4"
      />
      <path
        d="M233.743 153.321c-.487-.199-1.019-.266-1.551-.332-1.596-.2-4.521-.953-4.809-.576-.31.376.066 1.972 1.662 2.105 1.352.133 3.058.598 4.898 1.263 0 0 .288-2.283-.2-2.46m-1.884 4.677c-.953.11-4.543.044-5.208-.333-.377-.222-.864-.886-1.441-1.507-.554-.643-1.218-1.197-1.662-1.352-.376-.133-.842-.022-1.152.155-.31.178-.443.421-.2.577.51.332 1.33 1.241 2.084 2.171.753.931 1.418 1.862 2.172 2.061.62.156 1.374.355 2.216.399.975.156 2.681.421 3.789.2.665-.333.089-2.46-.598-2.371"
        fill="#FCC2B4"
      />
      <path
        d="M232.878 157.732c.045 0 .089-.023.089-.067.022-.044.022-.089-.044-.133a5.9 5.9 0 0 1-2.438-2.659q-.033-.067-.067-.067c-.044 0-.088 0-.11.044-.023.023-.023.045 0 .089a6 6 0 0 0 2.526 2.77c.022.023.044.023.044.023m-2.127.309c.023 0 .023-.022.023-.044s-.023-.044-.045-.044-2.526-.045-3.368-.133c-.732-.089-.976-.355-1.751-1.241a7 7 0 0 0-.399-.444c-1.086-1.241-1.64-1.352-2.349-1.374-.687-.022-.842.621-.842.643s0 .044.022.044.044 0 .044-.022.155-.598.776-.576c.687.022 1.219.133 2.305 1.352.155.177.288.31.398.443.798.909 1.02 1.175 1.796 1.263.864.089 3.346.133 3.39.133m-4.994-2.851-.017.109 3.023.465.017-.109z"
        fill="#BA6549"
      />
      <path
        d="m258.052 183.971 19.968-2.238c.488-.067.732-.842.444-1.441l-12.921-25.619c-.221-.443-.598-.687-.953-.642l-19.236 2.149c-.754.089-1.108 1.263-.643 2.15l12.699 25.198c.155.31.399.465.642.443"
        fill="#DADADA"
      />
      <path
        d="m257.41 184.038 19.968-2.239c.487-.066.731-.842.443-1.44l-12.92-25.619c-.222-.444-.599-.687-.953-.643l-19.237 2.15c-.753.088-1.108 1.263-.643 2.149l12.699 25.198c.133.311.377.466.643.444"
        fill="#ABB0BA"
      />
      <path
        d="M269.156 176.059c-6.87.244-14.05-2.415-19.17-7.978l7.491 14.871 19.503-2.172-2.948-5.873c-1.573.709-3.236 1.108-4.876 1.152"
        fill="#989DA6"
      />
      <path
        d="M272.613 170.497c2.105-.864 4.41 1.352 10.017 3.501.554.222 1.174.466 1.839.754-.354 1.108-.687 2.238-1.063 3.324-.266.776-1.175 1.042-1.862.576-.776-.531-1.507-.82-2.15-.731-3.834.554-6.626-.399-6.626-.399s-.82 1.773-2.039 1.684c-1.219-.066-2.261-2.105-2.881-2.659-.621-.51 2.681-5.164 4.765-6.05"
        fill="#FCC2B4"
      />
      <path
        d="M279.883 177.81s16.355 8.599 21.164 8.776 6.738-3.812 5.585-6.117c-1.174-2.304-4.078-3.856-7.623-3.967-3.546-.088-17.752-2.969-17.752-2.969zm-6.072-35.038c-5.252-1.839-7.446-6.67-6.693-10.881.466-2.615-.266-6.006-.177-8.843.222-2.526 1.108-4.609 4.011-5.141 5.984-1.108 17.664 1.241 15.181 10.261 0 0 3.413-1.086 3.28 3.125-.133 4.21-3.147 4.543-4.011 4.787-.022-.023-4.61 9.13-11.591 6.692"
        fill="#FCC2B4"
      />
      <path
        d="M267.006 125.663s1.219-3.435 6.05-2.526c4.831.886 4.942 3.723 10.372 1.795 0 0 .199 3.435 1.928 4.898s5.518-7.956 3.036-9.087c-2.482-1.152-21.231-3.324-21.386 4.92"
        fill="#FBA896"
      />
      <path
        d="M273.411 135.813c0-.088-.31-.132-.488-.509a1.1 1.1 0 0 1-.11-.687c.022-.288.133-.599.265-.953.532-1.441.82-2.66.665-2.726-.155-.067-.709 1.064-1.241 2.504-.133.355-.244.754-.266 1.13 0 .2.022.377.089.554.066.178.155.311.244.422.199.221.443.332.598.354s.244-.044.244-.089"
        fill="#F69D7D"
      />
      <path
        d="M275.451 128.167c.066.067.31-.044.709-.199a4.4 4.4 0 0 1 1.573-.288c.599 0 1.175.177 1.552.332.199.089.354.133.465.2.111.044.2.066.222.022s0-.111-.067-.222a1.8 1.8 0 0 0-.421-.376c-.377-.289-1.019-.554-1.773-.554-.731 0-1.396.243-1.773.509-.376.244-.532.51-.487.576m-3.546.134c.045-.067-.088-.333-.487-.599-.377-.288-1.042-.554-1.773-.554-.754 0-1.396.244-1.795.51-.2.133-.333.266-.421.377-.089.111-.111.177-.089.222.022.044.111.022.222-.023.11-.044.288-.11.487-.177a4.4 4.4 0 0 1 1.574-.288c.642 0 1.174.177 1.573.332.399.133.643.266.709.2m4.609 2.238c-.088.665.244 1.307.754 1.396.51.111 1.019-.355 1.108-1.042.089-.664-.244-1.307-.754-1.396-.509-.088-1.019.377-1.108 1.042m-7.491.554c-.067.665.243 1.286.709 1.374s.908-.399.997-1.063c.067-.665-.244-1.286-.709-1.375s-.909.399-.997 1.064"
        fill="#3B4159"
      />
      <path
        d="M278.465 123.181c3.59.732 7.313.133 7.313.133-1.241 1.197-1.374 5.098-.842 7.469.465 2.105 3.657 0 4.366-.51.155-1.263 2.216-3.79.509-6.804-1.241-2.194-18.593-9.817-21.275-6.958-4.056 4.299-1.596 9.551-1.596 9.551 1.108-6.227 7.912-3.634 11.525-2.881"
        fill="#3F3C51"
      />
      <path
        d="M287.794 133.442s-1.44.022-2.105-.687.909-7.025.909-7.025-2.039-1.507-2.217-3.834c-.199-2.305 1.264-3.613 3.657-3.635 1.352-.022 3.125.931 4.41 1.729.798.509.798 1.706-.022 2.194 0 0-.953 5.164-1.595 6.582-.665 1.418-3.037 4.676-3.037 4.676"
        fill="#3F3C51"
      />
      <path
        d="M289.412 131.27c.088-2.637-1.219-3.191-2.217-3.235-.62-.023-.975.908-1.13 1.529-1.041 3.856-.665 6.515-.665 6.515.865-.266 3.879-.598 4.012-4.809"
        fill="#FCC2B4"
      />
      <path
        d="M288.15 130.162c.332.998.089 2.106-.133 3.103-.066.288-.155.621-.355.798-.199.199-.554.177-.687-.089s0-.576.089-.864c.089-.266.133-.665-.089-.82-.11-.066-.221-.044-.332-.111-.244-.133-.266-.51-.244-.82.045-.421.133-.842.266-1.219.133-.376.355-.775.709-.775.333-.023.643.399.776.797"
        fill="url(#f)"
      />
      <path
        d="M271.617 136.9c1.662.199 3.546-.222 5.496-.82 0 0 .532 2.681-1.861 3.08-3.568.621-3.635-2.26-3.635-2.26"
        fill="#fff"
      />
      <path
        d="M276.492 121.94s-3.48 2.526-8.422.776c-4.942-1.751-5.23-4.544-5.23-4.544s4.1-.288 6.582-3.124c2.482-2.859 10.305-5.918 16.91-2.327 6.582 3.59 5.296 9.219 1.728 10.283s-5.917-1.153-6.804-.621c-.864.554-2.282 1.153-4.764-.443"
        fill="#3F3C51"
      />
      <path
        d="M202.81 78.784c-15.726-.376-33.062-10.026-33.062-10.026s-17.231 9.823-32.949 10.364c0 0-5.987 49.383 33.355 66.396 39.155-17.419 32.656-66.734 32.656-66.734"
        fill="#0056D5"
      />
      <path
        d="M202.811 78.31c-15.727-.36-33.055-9.559-33.055-9.559s-17.238 9.379-32.957 9.905c0 0-6.002 47.119 33.34 63.342 39.155-16.636 32.672-63.688 32.672-63.688"
        fill="#3771F5"
      />
      <path
        d="M199.765 80.867c-14.267-.323-29.994-8.657-29.994-8.657s-15.636 8.5-29.903 8.966c0 0-5.445 42.674 30.242 57.37 35.537-15.065 29.655-57.679 29.655-57.679"
        fill="#3771F5"
      />
      <path
        d="M197.846 82.44c-13.35-.301-28.068-8.1-28.068-8.1s-14.636 7.95-27.978 8.393c0 0-5.092 39.936 28.301 53.685 33.25-14.102 27.745-53.979 27.745-53.979"
        fill="#F5F5F5"
      />
      <path
        d="M196.38 83.191c-12.65-.293-26.594-7.837-26.594-7.837s-13.861 7.687-26.511 8.116c0 0-4.821 38.62 26.82 51.925 31.505-13.628 26.285-52.204 26.285-52.204"
        fill="#F5F5F5"
      />
      <path
        d="M194.23 84.515c-11.62-.278-24.435-7.378-24.435-7.378s-12.741 7.227-24.361 7.626c0 0-4.422 36.326 24.646 48.841 28.956-12.808 24.15-49.09 24.15-49.09"
        fill="#fff"
      />
      <path
        d="m169.793 77.137.293 56.467c28.949-12.815 24.143-49.097 24.143-49.097-11.62-.27-24.436-7.37-24.436-7.37"
        fill="#F5F5F5"
      />
      <path
        d="M183.972 106.386c0 7.799-6.326 14.125-14.125 14.125s-14.124-6.326-14.124-14.125 6.325-14.124 14.124-14.124 14.125 6.325 14.125 14.124"
        fill="#2A62F5"
      />
      <path
        d="m172.735 106.273-5.746-.03a1.2 1.2 0 0 1-1.204-1.203l.023-3.227c.015-2.218 1.857-4.016 4.114-4.008 2.249.015 4.069 1.827 4.054 4.054l-.023 3.226c0 .662-.549 1.196-1.218 1.188m-5.716-1.248 5.693.03.023-3.204c.007-1.549-1.256-2.82-2.828-2.828-1.572-.007-2.858 1.241-2.866 2.79z"
        fill="#fff"
      />
      <path
        d="m172.735 106.439-5.746-.03c-.767-.007-1.384-.617-1.384-1.369l.023-3.226c.015-2.31 1.94-4.182 4.295-4.167s4.249 1.903 4.234 4.219l-.023 3.227c-.007.744-.631 1.354-1.399 1.346m-2.812-8.468c-2.151-.016-3.919 1.714-3.934 3.843l-.023 3.226a1.03 1.03 0 0 0 1.023 1.038l5.746.03c.572 0 1.038-.459 1.038-1.03l.023-3.227c.015-2.12-1.722-3.865-3.873-3.88m2.97 7.25-6.054-.038.022-3.362c.016-1.639 1.377-2.963 3.046-2.956 1.67.008 3.016 1.354 3.009 2.994zm-5.693-.361 5.34.03.022-3.039a2.66 2.66 0 0 0-2.647-2.662c-1.474-.008-2.677 1.173-2.685 2.632z"
        fill="#fff"
      />
      <path
        d="M175.698 105.13c.008-.413-.421-.752-.955-.759l-9.725-.038c-.526 0-.962.331-.962.752l-.075 7.438c-.008.414.421.752.955.76l9.724.038c.527 0 .963-.331.963-.753zm-5.076 5.348-1.7-.008.308-1.451a1.08 1.08 0 0 1-.421-.873c.008-.579.451-1.053.993-1.045.541 0 .978.474.97 1.053 0 .361-.173.677-.436.865z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="a"
          x1="67.344"
          y1="21.303"
          x2="109.819"
          y2="36.004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8F17E" />
          <stop offset=".16" stopColor="#93E677" />
          <stop offset=".489" stopColor="#5EC864" />
          <stop offset=".957" stopColor="#089947" />
          <stop offset="1" stopColor="#009444" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="67.348"
          y1="8.209"
          x2="103.877"
          y2="50.366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8F17E" />
          <stop offset=".261" stopColor="#75D56C" />
          <stop offset=".611" stopColor="#36B257" />
          <stop offset=".867" stopColor="#0F9C49" />
          <stop offset="1" stopColor="#009444" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="62.24"
          y1="57.125"
          x2="89.903"
          y2="33.156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8F17E" />
          <stop offset=".222" stopColor="#9DEC7D" />
          <stop offset=".61" stopColor="#80DE7B" />
          <stop offset="1" stopColor="#5DCD79" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="264.889"
          y1="142.595"
          x2="257.72"
          y2="171.668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CACAFE" />
          <stop offset=".386" stopColor="#C5C5FC" />
          <stop offset=".84" stopColor="#B8B7F5" />
          <stop offset="1" stopColor="#B1B0F2" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="283.41"
          y1="142.731"
          x2="283.41"
          y2="202.376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CACAFE" />
          <stop offset=".469" stopColor="#C1C1FA" />
          <stop offset="1" stopColor="#B1B0F2" />
        </linearGradient>
        <linearGradient
          id="f"
          x1="286.69"
          y1="132.315"
          x2="288.117"
          y2="131.498"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F69D7D" />
          <stop offset="1" stopColor="#F69D7D" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default memo(TwoFactorIllustration);
